import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { userStatus } from '../userLogin/saga';
import { EMAIL_UPDATE, CONFIRM_EMAIL_CHANGE } from './actionTypes';
import { doneConfirmEmailUpdate, emailUpdateDone, errorConfirmEmailUpdate, emailUpdateError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* emailChangeCall(constAccessParams, action) {
    const { email } = action.data;
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    if (email) {
        const result = yield call(HeroAccountAPI.setEmail, newAccessParams, email);
        if (isSuccessResponse(result)) {
            yield call(userStatus, newAccessParams);
            yield put(emailUpdateDone({ email }));
        }
        else if (result.statusCode === 4) {
            yield put(logout());
        }
        else {
            yield put(emailUpdateError(result));
        }
    }
}
export function* watchEmailUpdateCalls(constAccessParams) {
    yield takeLatest(EMAIL_UPDATE, emailChangeCall, constAccessParams);
}
export function* emailChangeConfirmCall(constAccessParams, action) {
    const { email, activation_code } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.confirmEmail, newAccessParams, email, activation_code);
    if (isSuccessResponse(result)) {
        yield put(doneConfirmEmailUpdate(result.data));
    }
    else {
        yield put(errorConfirmEmailUpdate(result));
    }
}
export function* watchEmailUpdateConfirmCall(constAccessParams) {
    yield takeLatest(CONFIRM_EMAIL_CHANGE, emailChangeConfirmCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map